module.exports = __webpack_public_path__ + "static/media/instagram_logo.a85d458b.png";